import { HeadContent, Outlet, Scripts, createRootRouteWithContext } from "@tanstack/react-router";

import { Providers } from "@/components/_Providers";
import { RouterContext } from "@/main";
export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent
});

function RootComponent() {
  return (
    <Providers.Main>
      <HeadContent />
      <Outlet />
      <Scripts />
    </Providers.Main>
  );
}
